export default function getResource(label, vars = []) {
    const resources = {
        pickAStore: 'Pick A Store',
        showMap: 'Show map',
        hideMap: 'Hide map',
        showMoreLocations: 'Show more locations',
        continueToPickArtist: 'Continue to Pick an Artist, Date, and Time'
    };

    return resources[label];
}
